import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-53",
  "use": "icon-sheet_icon-53-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-53\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M15 12.651l-8.947 9.005c-.41.406-1.018.46-1.359.123l-2.47-2.445c-.341-.338-.286-.94.123-1.345L11.334 9M13 2.164l8.763 8.66a.25.25 0 010 .353h0l-3.586 3.586a.25.25 0 01-.354 0h0L9.237 6.177a.25.25 0 010-.354h0l3.586-3.586A.25.25 0 0113 2.164h0z\" /><path stroke-linecap=\"round\" d=\"M6 12l8 4M3 15l8 4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol